import { createContext, PropsWithChildren, useContext } from 'react';

type SortableItemContextValue = {
  id: number;
};

export const SortableItemContext =
  createContext<SortableItemContextValue | null>(null);

export function useSortableItemContext() {
  const context = useContext(SortableItemContext);
  return context;
}

export function usePossibleSortableItemContext() {
  try {
    return useContext(SortableItemContext);
  } catch {
    return null;
  }
}

export function SortableItemContextProvider({
  id,
  children,
}: PropsWithChildren<{ id: number }>) {
  return (
    <SortableItemContext.Provider
      value={{
        id,
      }}
    >
      {children}
    </SortableItemContext.Provider>
  );
}
